module.exports = __webpack_public_path__ + "img/overfold-card-wire.66d5bee5.png";